import { UpdateQuizSessionQuestionStateCommandPayload,
         UpdateQuizSessionNavigationCommandPayload,
         UpdateQuizSessionQuestionTimesCommandPayload } from './quiz-session-commands'
import { QuizSessionQuestionStatesState,
         QuizSessionNavigationState,
  QuizSessionQuestionTimesState } from './quiz-session-state-content'

export function reduceQuizSessionQuestionStates(
  states: QuizSessionQuestionStatesState,
  payload: UpdateQuizSessionQuestionStateCommandPayload): QuizSessionQuestionStatesState {

      const state = {
        type: payload.type,
        state: payload.state,
        answer: payload.answer,
        phase: payload.phase,
        result: {
          score: payload.result.score
        }
      }
      const newStates = [ ...states ]
      newStates.splice(payload.questionIndex, 1, state)

  return newStates
}

export function reduceQuizSessionNavigation(_navigation: QuizSessionNavigationState,
                                            payload: UpdateQuizSessionNavigationCommandPayload
                                           ): QuizSessionNavigationState {

  return {
          questionIndex: payload.questionIndex,
          lastIndex: payload.lastIndex
  }
}

export function reduceQuizSessionQuestionTimes(_state: QuizSessionQuestionTimesState,
                                               payload: UpdateQuizSessionQuestionTimesCommandPayload
                                              ): QuizSessionQuestionTimesState {
  return payload.questionTimes.map(x => {
          if (x.firstShownTime === null) { return null }
          return {
            firstShownTime: x.firstShownTime,
            seconds: x.seconds
          }
        })
}
